import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import ComponentErrorBoundary from '../../../components/component-error-boundary';

export default function Tags(props) {
  return (
    <div>
    <ComponentErrorBoundary value="select database autocomplete">
      <Autocomplete
        autoHighlight
        disableClearable={true}
        disabled={props.disabled===undefined?false:props.disabled}
        options={props.fileColumns}
        getOptionLabel={option => option.envTypeName || option.name || option.label || option }
        value={props.value}
        onChange={(event, newValue) => {props.onSelectValue(newValue);}}
        renderInput={params => {
          return (
            <TextField
              {...params}
              variant="standard"
              label={props.label}
              margin="normal"
              fullWidth
            />
          );
        }}
      />
     </ComponentErrorBoundary>
    </div>
  );
}
